/**
 * VibeCats — Sistema Central de Animações
 *
 * Gerencia timelines, registra animações por seção e responde a mudanças de viewport.
 */

const Animations = (($) => {
    'use strict';

    // Armazena todas as timelines registradas
    const timelines = {};
    const cleanupFns = [];

    /**
     * Registra a timeline de uma seção.
     * @param {string} name  — identificador único (ex: 'hero', 'about')
     * @param {Function} buildFn — função que cria e retorna a timeline
     */
    function register(name, buildFn) {
        timelines[name] = { build: buildFn, tl: null };
    }

    /**
     * Constrói (ou reconstrói) a timeline de uma seção.
     * @param {string} name
     * @returns {gsap.core.Timeline|null}
     */
    function build(name) {
        const entry = timelines[name];
        if (!entry) return null;
        // Mata timeline anterior se existir
        if (entry.tl) {
            entry.tl.kill();
            entry.tl = null;
        }
        // Cria nova timeline
        entry.tl = entry.build($);
        return entry.tl;
    }

    /**
     * Constrói todas as timelines registradas.
     */
    function buildAll() {
        Object.keys(timelines).forEach((name) => build(name));
        ScrollTrigger.refresh();
    }

    /**
     * Mata todas as timelines e faz cleanup.
     */
    function killAll() {
        Object.keys(timelines).forEach((name) => {
            if (timelines[name].tl) {
                timelines[name].tl.kill();
                timelines[name].tl = null;
            }
        });
        cleanupFns.forEach((fn) => fn());
        cleanupFns.length = 0;
    }

    /**
     * Registra função de cleanup para ser chamada no destroy.
     * @param {Function} fn
     */
    function addCleanup(fn) {
        cleanupFns.push(fn);
    }

    /**
     * Cria MatchMedia para responsividade das animações.
     * @param {object} config — { desktop: fn, tablet: fn, mobile: fn }
     * @returns {gsap.MatchMedia}
     */
    function createMatchMedia(config) {
        const mm = $.matchMedia();
        const breakpoints = {
            desktop: '(min-width: 1025px)',
            tablet: '(min-width: 769px) and (max-width: 1024px)',
            mobile: '(max-width: 768px)',
        };

        Object.keys(config).forEach((key) => {
            if (config[key] && breakpoints[key]) {
                mm.add(breakpoints[key], config[key]);
            }
        });

        addCleanup(() => mm.revert());
        return mm;
    }

    /**
     * Cria uma animação de fade-in com deslocamento para elementos.
     * @param {string|HTMLElement} el
     * @param {object} vars — opcionais (y, duration, delay, etc)
     * @returns {gsap.core.Timeline}
     */
    function fadeInUp(el, vars = {}) {
        const tl = $.timeline({ paused: true });
        tl.from(el, {
            y: vars.y || 60,
            opacity: 0,
            duration: vars.duration || 1,
            ease: vars.ease || 'power3.out',
            stagger: vars.stagger || 0,
            delay: vars.delay || 0,
            ...vars,
        });
        return tl;
    }

    return {
        register,
        build,
        buildAll,
        killAll,
        addCleanup,
        createMatchMedia,
        fadeInUp,
        get timelines() { return timelines; },
    };
})(gsap);

/*
document.addEventListener('DOMContentLoaded', () => {

    const badgeDicas = document.querySelector('.dicas__badge');
    const personImg = document.querySelector('.dicas__person__img');
    const cards = document.querySelectorAll('.dicas__card__item');

    if (!badge || !personImg || !cards.length) return;

    let currentStep = 0;
    let isAnimating = false;

    const images = [
        personImg.dataset.img1,
        personImg.dataset.img2,
        personImg.dataset.img3
    ];

    badgeDicas.addEventListener('click', () => {

        if (isAnimating) return;

        if (currentStep === 2) {

            isAnimating = true;

            // Volta para a primeira imagem
            personImg.src = images[0];

            // Aguarda a troca da imagem e reseta os cards
            setTimeout(() => {

                cards.forEach(card => {
                    card.classList.remove('is-falling');

                    // Força o reflow para permitir nova animação
                    void card.offsetWidth;
                });

                currentStep = 0;
                isAnimating = false;

            }, 100);

            return;
        }

        isAnimating = true;

        personImg.src = images[currentStep + 1];

        const card = cards[currentStep];

        requestAnimationFrame(() => {
            card.classList.add('is-falling');
        });

        currentStep++;

        setTimeout(() => {
            isAnimating = false;
        }, 900);

    });

});
*/


document.addEventListener('DOMContentLoaded', () => {

    const badgeDicas = document.querySelector('.dicas__badge');
    const personImg = document.querySelector('.dicas__person__img');
    const cards = document.querySelectorAll('.dicas__card__item');

    if (!badgeDicas || !personImg || !cards.length) return;

    let currentStep = 0;
    let isAnimating = false;

    const img1 = personImg.dataset.img1;
    const img2 = personImg.dataset.img2;

    // Garante que a animação comece na imagem 1
    personImg.src = img1;

    badgeDicas.addEventListener('click', () => {

        if (isAnimating) return;

        isAnimating = true;

        // Mostra a imagem 2
        personImg.src = img2;

        // Seleciona o próximo card
        const card = cards[currentStep];

        // Executa a animação de queda
        requestAnimationFrame(() => {
            card.classList.add('is-falling');
        });

        // Volta para a imagem 1 após um pequeno intervalo
        setTimeout(() => {
            personImg.src = img1;
        }, 300);

        currentStep++;

        // Quando todos os cards caírem, reinicia a sequência
        setTimeout(() => {

            if (currentStep >= cards.length) {

                cards.forEach(card => {
                    card.classList.remove('is-falling');
                    void card.offsetWidth;
                });

                currentStep = 0;
            }

            isAnimating = false;

        }, 900);

    });

});


document.addEventListener("DOMContentLoaded", () => {

    const elements_up = document.querySelectorAll(".fade-up-on-scroll");
    const elements_left = document.querySelectorAll(".fade-left-on-scroll");
    const elements_right = document.querySelectorAll(".fade-right-on-scroll");
    const elements_in = document.querySelectorAll(".fade-in-on-scroll");
    const text_extended = document.querySelectorAll(".extended-text-in");

    const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

            if (entry.isIntersecting){

                const delay = entry.target.dataset.delay || 0;

                setTimeout(() => {
                    entry.target.classList.add("is-visible");
                }, delay);
            }else{
                entry.target.classList.remove("is-visible");
            }

            //observer.unobserve(entry.target);

        });

    }, {
        threshold: 0.5,
        rootMargin: "0px 0px -20% 0px"
    });

    elements_up.forEach(el => observer.observe(el));
    elements_left.forEach(el => observer.observe(el));
    elements_right.forEach(el => observer.observe(el));
    elements_in.forEach(el => observer.observe(el));
    text_extended.forEach(el => observer.observe(el));

});